import type { ComponentType } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface ConfirmModalHeaderProps {
    icon: ComponentType<{ className?: string }>;
    iconClassName: string;
    title: string;
    onClose: () => void;
    disabled: boolean;
}

export function ConfirmModalHeader({
    icon: Icon,
    iconClassName,
    title,
    onClose,
    disabled
}: ConfirmModalHeaderProps) {
    return (
        <div className="px-5 py-4 border-b border-gray-200 flex items-center justify-between">
            <div className="flex items-center gap-2">
                <Icon className={iconClassName} />
                <span className="font-bold text-[15px] text-gray-800">{title}</span>
            </div>
            <button
                type="button"
                onClick={onClose}
                disabled={disabled}
                className="text-gray-400 hover:text-gray-700 transition-colors disabled:opacity-50"
            >
                <XMarkIcon className="w-4 h-4" />
            </button>
        </div>
    );
}
